var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isBlank)?_c('div',_vm._l((_vm.value),function(item){return _c('div',{key:item.id},[_c('a',{attrs:{"href":item.publicUrl,"download":"","target":"_blank"}},[_vm._v(_vm._s(_vm.truncate(item.name)))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }